import { render } from "./DistributorList.vue?vue&type=template&id=3576472d&ts=true"
import script from "./DistributorList.vue?vue&type=script&lang=ts"
export * from "./DistributorList.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/dashboard/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__